var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header class="row">\n  <div class="col-11">\n    <div class="row">\n      <div class="col-9">\n        <label class="control-label">Phrase</label>\n      </div>\n      <div class="col-3">\n        <label class="control-label">Spoken by</label>\n      </div>\n    </div>\n  </div>\n</header>\n';
}
return __p;
};
